module.exports = __webpack_public_path__ + "img/health.9ab2a2df.jpg";